import config, { Environment } from '../../../config/config'
import { StagingAccount } from '../../../enums/enums'

/**
 * Checks for the test production account or any staging account.
 * A development environment will also pass the check.
 */
export const hasUrlFeatureFlag = (): boolean => {
  const isEnabled = config.environment !== Environment.PRODUCTION || config.getAccountSlug() === 'test'
  return isEnabled
}

/**
 * Enables the Dax MCQ animation for the studio-app (staging) account and the
 * test (production) account only. Local development also passes because localhost
 * resolves to the studio-app slug.
 */
export const hasDaxAnimationFeatureFlag = (): boolean => {
  const isStudioApp = config.getAccountSlug() === StagingAccount.StudioApp
  const isTestProd = config.environment === Environment.PRODUCTION && config.getAccountSlug() === 'test'

  return isStudioApp || isTestProd
}

/**
 * Checks for D2C accounts (train and join26 in production, studio2 in staging).
 * A development environment will also pass the check.
 */
export const hasUrlFeatureFlagTrain = (): boolean => {
  const slug = config.getAccountSlug()
  const isTrain = config.environment === Environment.PRODUCTION && slug === 'train'
  const isJoin26 = config.environment === Environment.PRODUCTION && slug === 'join26'
  const isStudio2 = config.environment === Environment.STAGE && slug === 'studio2'
  const isDev = config.environment === Environment.DEVELOPMENT

  return isTrain || isJoin26 || isStudio2 || isDev
}
